import { motion } from "framer-motion";
import { useLang, copy } from "@/i18n";
import { MaskedLine, Reveal } from "@/components/Reveal";

export default function Hero() {
  const { lang } = useLang();
  const c = copy[lang].hero;

  return (
    <>
      <section
        id="inizio"
        data-testid="hero-section"
        className="relative min-h-screen flex flex-col justify-end px-6 md:px-14 pb-10"
      >
        <div className="absolute left-1/2 top-[40%] -translate-x-1/2 -translate-y-1/2 flex flex-col items-center text-center">
          <motion.div
            data-testid="hero-logo"
            initial={{ opacity: 0, scale: 1.05 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 3, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
          >
            <motion.img
              src="/fmf-logo.png"
              alt="FMF — emblema in ergal, taglio laser, 3 mm"
              animate={{ y: [0, -9, 0] }}
              transition={{ duration: 9, repeat: Infinity, ease: "easeInOut" }}
              className="w-64 md:w-96"
              style={{
                filter:
                  "drop-shadow(0 3px 0 rgba(0,0,0,0.85)) drop-shadow(0 26px 48px rgba(0,0,0,0.8)) drop-shadow(0 0 26px rgba(36,118,214,0.22))",
              }}
            />
          </motion.div>
          <motion.p
            data-testid="hero-kicker"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 2.4, delay: 1.2 }}
            className="mt-8 font-mono-fmf text-[13px] md:text-lg uppercase tracking-[0.25em] md:tracking-[0.45em] text-[var(--graphite)]"
          >
            {c.kicker}
          </motion.p>
        </div>

        <h1
          data-testid="hero-statement"
          className="font-serif-fmf font-light leading-[1.2] tracking-tight text-2xl md:text-4xl lg:text-5xl text-center"
        >
          <MaskedLine delay={1.6}>{c.line1}</MaskedLine>
          {c.lines2.map((l, i) => (
            <MaskedLine key={l} delay={2.2 + i * 0.5} className="italic fmf-gold-text mt-8">
              {l}
            </MaskedLine>
          ))}
        </h1>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 2, delay: 4 }}
          className="mt-16 flex flex-col items-center justify-center gap-5"
        >
          <span className="cue-line block w-16 h-px bg-[var(--graphite)]" />
          <span
            data-testid="hero-scroll-cue"
            className="font-mono-fmf text-[15px] uppercase tracking-[0.4em] text-[var(--graphite)]"
          >
            {c.cue}
          </span>
        </motion.div>
      </section>

    </>
  );
}
